// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container[data-v-7589b93f] {\n  margin-top: 20%;\n  padding: 0 0.53333rem;\n  text-align: center;\n}\n.van-hairline--bottom[data-v-7589b93f]:after {\n  border-bottom-width: 0rem;\n}\n[data-v-7589b93f] .van-nav-bar__arrow {\n  color: #000000;\n}\n.user-agreement-box[data-v-7589b93f] {\n  display: flex;\n  justify-content: center;\n  margin-top: 0.26667rem;\n  color: #666666;\n  font-size: 0.32rem;\n}\n.user-agreement-link[data-v-7589b93f]:visited {\n  color: #0000ee;\n}\n", ""]);
// Exports
module.exports = exports;
